import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { LoginScreen } from './components/auth/LoginScreen';
import { Shell } from './components/shell/Shell';
import { AuthProvider, useAuth } from './lib/auth';
import { Ajustes } from './pages/Ajustes';
import { Assinantes } from './pages/Assinantes';
import { Campanhas } from './pages/Campanhas';
import { Dinheiro } from './pages/Dinheiro';
import { Inicio } from './pages/Inicio';
import { Loja } from './pages/loja/Loja';
import { Produtos } from './pages/Produtos';
import { ProdutoEntrega } from './pages/produtos/ProdutoEntrega';
import { Vendas } from './pages/Vendas';

function Gate() {
  const { status } = useAuth();

  if (status === 'checking') return null;
  if (status === 'logged_out') return <LoginScreen />;

  return (
    <Routes>
      <Route element={<Shell />}>
        <Route index element={<Inicio />} />
        <Route path="produtos" element={<Produtos />} />
        <Route path="produtos/:id" element={<ProdutoEntrega />} />
        <Route path="loja" element={<Loja />} />
        <Route path="vendas" element={<Vendas />} />
        <Route path="assinantes" element={<Assinantes />} />
        <Route path="dinheiro" element={<Dinheiro />} />
        <Route path="campanhas" element={<Campanhas />} />
        <Route path="ajustes" element={<Ajustes />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Gate />
      </AuthProvider>
    </BrowserRouter>
  );
}
